import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { ProductsService } from '../../services/products.service';

@Component({
  selector: 'app-addmultipleproduct',
  templateUrl: './addmultipleproduct.component.html',
  styleUrls: ['./addmultipleproduct.component.css']
})
export class AddmultipleproductComponent implements OnInit {
  action: any;
  msg: any;
  flag: any;
  url: any;
  id: number;
  samecat: any;
  similarcat: any;
  loading: any;

product:any;
searchproduct:any;
food = [];
ptype:any;
data2: any;
searchbrand: any;
namearr:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data , public dialogRef: MatDialogRef<AddmultipleproductComponent>,
  private ProductService: ProductsService, public dialog: MatDialog, public snackBar: MatSnackBar
 // private brandService: BrandService,
) {
  this.flag = 0;
  //this.id = 1;
  //this.url = 'Dog';
  //this.flag = 1;
    //this.getChildCategory(this.id, this.url);

    this.namearr = data.name;

  }

  ngOnInit() {
    this.ProductService.getProducts()
    .subscribe(
      (x)=>{
        this.product = x;
      });
      this.ProductService.getBrands()
      .subscribe(
       (x) => this.data2 = x,
       (error: Response) => console.log(error)
        );
  }

  showAlert() {
    this.snackBar.open(this.msg, this.action , {
      duration: 4000,
    });
 }
  isAlreadyAdd(na){
    for(let i =0 ;i<this.namearr.length; i ++){
      if(this.namearr[i] == na){
        return true;
      }
    }
  }
  clearFilter(){
    this.searchbrand = undefined;
    this.searchproduct = undefined;
  }
  addPro(p){
    this.dialogRef.close(p);
  }
  addFood(e, id,price,splprice,name){
    if (e.target.checked) {
      var obj = {id:id,price:price,splprice:splprice,name:name}
      this.food.push(obj);
    }
  
   if ( !e.target.checked) {
     for ( let i = 0 ; i < this.food.length; i++) {
       if ( this.food[i].id == id ) {
         this.food.splice(i , 1);
       }
     }
   }
   
  }  

  addedFood(id, price, splprice, name){
      var obj = {id:id,price:price,splprice:splprice,name:name}
      this.food.push(obj);
      this.msg = "This product is selected for your Pet. Please click on Confirm Selection.";
      this.showAlert();
  }

  confirmFood() {
    this.namearr = undefined;
    delete this.namearr;
    delete this.product;
    this.dialogRef.close(this.food);
  } 



  getChildCategory(pcid, pcname) {
    this.loading = true;
    this.ProductService.getSimilerproduct(pcid)
    .subscribe(
    (x) => {
      this.similarcat = x;
      this.loading = false;
    });
    }

    goToSimilarProduct(id, url) {
      this.ProductService.getSimilerproduct(id)
      .subscribe(
      (x) => {
        this.samecat = x;
        if (this.samecat && this.samecat.length > 0 && (url === 'Dog' ||
          url === 'Cat' || url === 'Bird' || url === 'Fish' )) {
        // this.router.navigate(['/store/categories/', id, url]);
        this.flag = 2;
         }  else {
          this.ProductService.getcatProduct(this.id)
          .subscribe(
            (data) => {
              this.data = data;
              this.loading = false;
            });
        // this.router.navigate(['/store/products/', id, url]);
         }
      });
    }

    goToSimilarProduct1(id, url) {
      this.flag = 2;
     // this.goToSimilarProduct(id, url);
      this.loading = true;
     this.ProductService.getcatProduct(id)
     .subscribe(
       (data) => {
         this.data = data;
         this.loading = false;
       });
    }

    cancel1() {
      this.flag = 1;
    }

    cancel2() {
      this.dialogRef.close();
    }

    check(id, name) {
      this.id = id;
      this.url = name;
      this.flag = 1;
      this.getChildCategory(this.id, this.url);
    }

    back(){
      this.flag = 0;
    }

}
